import React, { useState } from "react";
import { Button, Spinner } from "@lemonadetraining/web-ui";
import { useDispatch } from "react-redux";
import { IconTrash } from "@tabler/icons-react";

/* Routing */
import { useNavigate } from "react-router-dom";

/* Own Modules */
import WidgetCard from "../components/Cards/WidgetCard";
import MyModal from "@lemonadetraining/web-shared/components/MyModal";
import { archiveProduct } from "@lemonadetraining/web-shared";
import { notifyActions, NOTIFICATION_TYPE } from "@lemonadetraining/web-shared";

/* =================== Program Control Panel ==================== */
/* active or deactivate a product, meaning Whether the product is available for purchase. */
/* archiving a product means that setting the product active status to False */
const ProductArchiveWidget_Modal = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { isOpen } = props;

  const closeModal = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  /* ------ Archiving Product ------- */
  const onArchiveProduct = async () => {
    setLoading(true);

    try {
      await archiveProduct(props.productId, props.productType);

      // send notification
      dispatch(
        notifyActions.sendNotification({
          type: NOTIFICATION_TYPE.success,
          message: `Product ${props.productId} been archived!`,
        })
      );

      // redirect to the previous page
      navigate(-1);
    } catch (error) {
      // send notification
      dispatch(
        notifyActions.sendNotification({
          type: NOTIFICATION_TYPE.error,
          message: error.message,
        })
      );
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  /* ====================[UI Return]===================== */
  return (
    <MyModal open={isOpen} onClose={closeModal} title="Archive Product" showTitle={false}>
      <WidgetCard title={"Archive Product"} isLoading={loading}>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-4">
            <h3 className="text-base font-semibold">
              Are you sure you want to archive this Product?
            </h3>
            <span className="text-xs text-muted-foreground">
              {`Archiving takes the product off sale: no one can buy it any more. Anyone who
              already has it keeps it — existing subscriptions are not cancelled and continue
              until the subscriber cancels them.`}
            </span>
            <div className="flex flex-row justify-between">
              <Button
                size="lg"
                variant="outline"
                onClick={closeModal}
                className="text-destructive border-destructive"
              >
                Cancel
              </Button>
              <Button size="lg" variant="destructive" disabled={loading} onClick={onArchiveProduct}>
                {loading && <Spinner className="mr-2 h-4 w-4" />}
                Archive
                <IconTrash className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </WidgetCard>
    </MyModal>
  );
};

export default ProductArchiveWidget_Modal;
